// extracted by mini-css-extract-plugin
export default {"Indicator":"Indicator_Indicator__M+-wh","red":"Indicator_red__S3e-3","blue":"Indicator_blue__6E7lW","green":"Indicator_green__7Tgl1"};